import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { PersonalizedFeaturedTrialType } from '../shared/Carousel/Carousel.types';
import CarouselWrapper from '../shared/Carousel/CarouselWrapper/CarouselWrapper';
import useFeatureTrialResultList from 'lib/hooks/coveo/useFeatureTrialResultList';
import featuredHeadlessEnginee from 'lib/utils/coveo/featuredHeadlessEnginee';
import { Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { useEffect, useState } from 'react';
import { StCommonTypography } from '../shared/Container/Container.styles';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';

const PersonalizedFeaturedTrial = (props: PersonalizedFeaturedTrialType): JSX.Element => {
  const theme = useTheme();
  const { sitecoreContext } = useSitecoreContext();
  const isMyProfilePage = sitecoreContext?.route?.fields?.isMyProfilePage;
  const [trialsList, setTrialsList] = useState<any>([]);
  const { state } = useFeatureTrialResultList(featuredHeadlessEnginee);
  const isAuthenticated: boolean = useSelector(
    (state: RootState) => state.authentication.isAuthenticated
  );

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setTrialsList(state?.results);
    }
  }, [state]);

  if (!isAuthenticated) {
    return <></>;
  }

  if (!props?.fields) {
    return <></>;
  }

  return (
    <>
      {Array.isArray(trialsList) && trialsList.length > 0 ? (
        <Box
          id="personalized-featured-trial"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            padding: '48px 41px',
            maxWidth: '1400px',
            marginInline: 'auto',
          }}
        >
          <StCommonTypography
            sx={{
              textAlign: 'center',
              fontWeight: 600,
              fontFamily: 'Proxima Nova',
              fontSize: '32px',
              lineHeight: '24px',
              marginBottom: '1rem',
              color: theme.palette.neutral8.main,
              [theme.breakpoints.down('sm')]: {
                fontSize: '24px',
                ...(isMyProfilePage && trialsList?.length > 0 && { textAlign: 'start' }),
              },
            }}
          >
            <Text field={props?.fields?.sectonTitle} />
          </StCommonTypography>
          <CarouselWrapper
            {...props}
            personalizedFeaturedTrialList={trialsList}
            identifier="personalized-featured-trials-carousal"
            callerComponent="personalized-featured-trials"
          />
        </Box>
      ) : (
        <></>
      )}
    </>
  );
};

export default PersonalizedFeaturedTrial;
